/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { OAuthClientUIConfiguration } from './OAuthClientUIConfiguration';
import {
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationFromJSONTyped,
    OAuthClientUIConfigurationToJSON,
} from './OAuthClientUIConfiguration';

/**
 * 
 * @export
 * @interface PutOauth2UiConfiguration201Response
 */
export interface PutOauth2UiConfiguration201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PutOauth2UiConfiguration201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PutOauth2UiConfiguration201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {OAuthClientUIConfiguration}
     * @memberof PutOauth2UiConfiguration201Response
     */
    result: OAuthClientUIConfiguration;
}

/**
 * Check if a given object implements the PutOauth2UiConfiguration201Response interface.
 */
export function instanceOfPutOauth2UiConfiguration201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PutOauth2UiConfiguration201ResponseFromJSON(json: any): PutOauth2UiConfiguration201Response {
    return PutOauth2UiConfiguration201ResponseFromJSONTyped(json, false);
}

export function PutOauth2UiConfiguration201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOauth2UiConfiguration201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': OAuthClientUIConfigurationFromJSON(json['result']),
    };
}

export function PutOauth2UiConfiguration201ResponseToJSON(value?: PutOauth2UiConfiguration201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': OAuthClientUIConfigurationToJSON(value.result),
    };
}

